import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-embedded-completed',
  templateUrl: './embedded-completed.component.html',
  styleUrl: './embedded-completed.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class EmbeddedCompletedComponent {
  private readonly route = inject(ActivatedRoute);

  protected readonly inquiryId =
    this.route.snapshot.queryParamMap.get('inquiryId');
}
